import { atom } from 'jotai';

// Number of mounted consumers that have opted the Spotlight in.
export const spotlightRefCountAtom = atom(0);

// Spotlight is active only while at least one consumer is registered.
export const spotlightEnabledAtom = atom(get => get(spotlightRefCountAtom) > 0);

// Open/close state of the Spotlight modal.
export const spotlightOpenAtom = atom(false);
